export default __webpack_public_path__ + "static/media/gallery_16.1365bda5.jpg";